import React from 'react';
import { ChoiceCard } from '@spark';
import {
    ADD_ANOTHER_ORDER,
    TOOL_SOURCE_TYPE_META,
    TOOL_SOURCE_TYPE_ORDER,
} from './agentConfigModel';

/**
 * Row of the tool-discovery choice cards.
 *
 * - No source yet (Figma 3926-8787): three large vertical cards
 *   (MCP / Swagger / Manual) sharing the 772px row.
 * - "Add Another One" (Figma 4012:16639): the compact horizontal 200px cards
 *   in the same MCP / Swagger / Manual order under the heading.
 *
 * Clicking a card appends a source of that type.
 */
const ToolDiscoveryChoiceCards = ({ heading = null, onSelect, disabled = false }) => {
    const compact = Boolean(heading);
    const order = compact ? ADD_ANOTHER_ORDER : TOOL_SOURCE_TYPE_ORDER;
    return (
        <div className={`cw-ac-choice${compact ? ' cw-ac-choice--compact' : ''}`}>
            {heading && <h4 className="cw-ac-choice__heading">{heading}</h4>}
            <div className="cw-ac-choice__cards" role="group" aria-label="Tool discovery type">
                {order.map((type) => {
                    const meta = TOOL_SOURCE_TYPE_META[type];
                    return (
                        <ChoiceCard
                            key={type}
                            layout={compact ? 'horizontal' : 'vertical'}
                            iconSlug={meta.iconSlug}
                            label={meta.label}
                            disabled={disabled}
                            onClick={() => onSelect(type)}
                            data-source-type={type}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default ToolDiscoveryChoiceCards;
